<template>
  <div id="visual-form" class="modal-form">
    <div class="upload-image-video" v-if="showUploadForm">
      <div class="form-upload">
        <p class="title">Upload or connect image</p>
        <div class="form-group row">
          <div class="col-sm-5">
            <label class="file-upload">
              <input type="file" @change="onInputFileChange" />
              Choose a file from your computer
            </label>
          </div>
          <div class="col-sm-7">
            <!-- <input type="text" class="form-control" placeholder="Video URL" /> -->
          </div>
        </div>
        <div class="form-group row mb-0" v-if="images.length > 0">
          <div class="col-sm-5 py-0">
            <label
              for="Filename"
              class="col-sm-12 col-form-label p-0 title-table"
              >Filename</label
            >
          </div>
          <div class="col-sm-7 py-0">
            <label for="Status" class="col-sm-12 col-form-label p-0 title-table"
              >Status</label
            >
          </div>
        </div>
        <div
          class="form-group row p-0"
          v-for="(item, index) in images"
          :key="index"
        >
          <div class="col-sm-5 py-0">
            <div class="col-sm-12 p-0">
              <input
                type="text"
                readonly
                class="form-control-plaintext p-0"
                id="staticEmail"
                :value="item.name"
              />
            </div>
          </div>
          <div class="col-sm-6 py-0">
            <div class="progress mt-2">
              <div
                class="progress-bar bg-success text-right"
                role="progressbar"
                :style="{ width: `${item.progress}%` }"
              >
                {{ item.progress }}%
              </div>
            </div>
          </div>
          <div class="col-sm-1 py-0">
            <!-- <label class="title-table2" @click="removeImage(index)">Cancel</label> -->
          </div>
        </div>
        <span class="close" @click="closeForm">Close</span>
      </div>
      <div class="text-center mt-5">
        <a href="javascript:void(0);" class="close-link" @click="closeForm"
          >SAVE & CLOSE</a
        >
        <button
          class="btn btn-next"
          @click="doShowFormEdit"
          :disabled="!uploadedMoment"
        >
          NEXT
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div
      class="edit-image-video"
      v-if="showEditForm && uploadedMoment && uploadedMoment.media"
    >
      <div class="form-edit-image-video">
        <div class="row">
          <div class="col-md-6">
            <p>
              <a href="#" @click="deleteMoment">DELETE</a>
            </p>
            <div class="img mb-2" v-if="uploadedMoment.media.url">
              <img :src="uploadedMoment.media.url" />
            </div>
            <div class="connected-experiences">
              <p>Connected experiences</p>
              <ExperiencePicker v-model="uploadedMoment.experiences" />
            </div>
          </div>
          <div class="col-md-6">
            <p class="title">Edit image/video file</p>
            <div class="description">
              <p v-if="uploadedMoment.createdAt">
                Upload date: {{ getFormatedDate(uploadedMoment.createdAt) }}
              </p>
              <p
                v-if="uploadedMoment.media.width && uploadedMoment.media.height"
              >
                Size: {{ uploadedMoment.media.width }} x
                {{ uploadedMoment.media.height }} pixel
              </p>
            </div>
            <div class="description2">
              <p>Description</p>
              <textarea
                v-model="uploadedMoment.content"
                rows="5"
                class="form-control"
                placeholder="Put a description to appear with your image. You can use hashtags (#) to connect this image to other experiences or contests."
              ></textarea>
            </div>
            <!-- <div class="description2">
							<p>Display on...</p>
							<ul>
								<li>This function is only available to portal owners</li>
							</ul>
						</div> -->
            <div class="description2">
              <p>Distribution</p>
              <ul>
                <li>
                  <img :src="icons.icon01" class="mr-1" /> Mongolia.travel
                </li>
                <li><img :src="icons.icon02" class="mr-1" /> Mongolia Taste</li>
                <li>
                  <img :src="icons.icon03" class="mr-1" /> Mongolia Tourism
                  Mobile Application
                </li>
              </ul>
            </div>
            <div class="description2">
              <p>Ownership</p>
              <div class="form-check">
                <input
                  class="form-check-input mt-2"
                  type="checkbox"
                  id="gridCheck"
                />
                <label class="form-check-label" for="gridCheck">
                  I confirm that I am the rightful owner of this content piece
                  and that it meet the ENWOKE terms &amp; conditions
                </label>
              </div>
            </div>
          </div>
        </div>
        <span class="close" @click="updateMoment">Close</span>
      </div>
      <div class="text-center mt-5">
        <a
          href="javascript:void(0);"
          class="close-link"
          @click="updateMoment(false)"
          >SAVE &amp; CLOSE</a
        >
        <button class="btn btn-next" @click="updateMoment(true)">
          SAVE &amp; PUBLISH
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>

      <v-dialog v-model="showDeleteDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Delete Content
          </v-card-title>

          <v-card-text>
            <h5 style="margin: 1rem 0">
              Are you sure for delete this content?
            </h5>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="onAgreeDelete"> Yes </v-btn>
            <v-btn color="red" text @click="showDeleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ImageEdit from "@/assets/images/edit-form.jpg";
import ExperiencePicker from "@/components/ExperiencePicker";
import icon01 from "@/assets/images/icon-edit-eye.png";
import icon02 from "@/assets/images/icon-edit-02.png";
import icon03 from "@/assets/images/icon-edit-03.png";
export default {
  components: {
    ExperiencePicker,
  },
  data() {
    return {
      img: ImageEdit,
      images: [],
      showUploadForm: true,
      showEditForm: false,
      showDeleteDialog: false,
      uploadedMoment: null,
      experience: [],
      icons: {
        icon01: icon01,
        icon02: icon02,
        icon03: icon03,
      },
    };
  },
  methods: {
    closeForm() {
      this.$emit("showVisualForm");
    },
    async updateMoment(published = false) {
      this.uploadedMoment.published = published;
      this.uploadedMoment = await this.$repo.moment.updateMoment(
        this.uploadedMoment
      );
      this.triggerUpdated();
      this.closeForm();
    },
    deleteMoment() {
      if (!this.uploadedMoment) return;
      this.showDeleteDialog = true;
    },
    async onAgreeDelete() {
      this.showDeleteDialog = false;
      const sucesss = await this.$repo.moment.deleteMoment(
        this.uploadedMoment.id
      );
      if (sucesss) {
        this.triggerUpdated();
        this.closeForm();
      }
    },
    doShowFormEdit() {
      this.showUploadForm = false;
      this.showEditForm = true;
    },
    removeImage() {
      this.images = [];
      this.$emit("removeImage");
    },
    onInputFileChange(e) {
      if (!e.target.files || e.target.files.length < 1) return;

      this.uploadFile(e.target.files[0]);
    },
    async uploadFile(file) {
      this.uploadedMoment = null;
      const fileObj = { name: file.name, progress: 0 };
      this.images = [fileObj];

      const data = await this.$repo.moment.uploadSingleMoment(file);
      fileObj.progress = 100;
      this.uploadedMoment = data;
      this.triggerUpdated();
    },
    triggerUpdated() {
      this.$emit("updated", this.uploadedMoment);
    },
    clearUploadQueue() {
      this.images = [];
    },
    getFormatedDate(date) {
      return moment(date).format("D/M/YYYY, HH:mm:ss");
    },
  },
};
</script>

<style lang="scss">
#visual-form {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  .close-link {
    color: white;
    text-decoration: underline;
	font-size: 14px;
	margin-right: 24px;
  }
  .btn-next {
    background-color: var(--primary-color);
    padding: 13px 50px;
    border-radius: 5px;
	font-size: 14px;
  }
  .upload-image-video {
    .form-upload {
      position: relative;
      margin: 0 auto;
      background-color: #fff;
      width: 71.14%;
      min-height: 610px;
      padding: 18px 30px;

      input[type="file"] {
        display: none;
      }

      .file-upload {
        border: 1px solid var(--primary-color);
        background-color: var(--primary-color);
        border-radius: 5px;
        display: inline-block;
        padding: 2px 30px;
        font-size: 12px;
        cursor: pointer;
        width: 100%;
        text-align: center;
      }

      .close {
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 24px;
        text-transform: uppercase;
        color: #b9b9b9;
        font-size: 12px;
      }
    }
  }

  .edit-image-video {
    .form-edit-image-video {
      position: relative;
      width: 71.14%;
      min-height: 610px;
      background-color: #fff;
      margin: 0 auto;
      padding: 20px 50px;

      .img {
        img {
          width: 100%;
        }
      }

      .connected-experiences {
        p {
          color: #58595b;
          font-size: 14px;
          font-weight: 600;
        }
      }

      .description {
        margin-bottom: 30px;
        p {
          color: #58595b;
          font-size: 14px;
          line-height: 12px;
        }
      }
      .description2 {
        margin-bottom: 30px;
        p {
          color: #58595b;
          font-size: 14px;
          line-height: 12px;
          font-weight: 600;
        }

        ul {
          list-style: none;
          padding: 0;
          li {
            display: flex;
            align-items: center;
            color: #58595b;
            font-size: 14px;
            font-weight: lighter;
          }
        }
      }

      .form-check-label {
        color: #58595b;
        font-size: 14px;
      }

      .close {
        cursor: pointer;
        position: absolute;
        top: 10px;
        right: 24px;
        text-transform: uppercase;
        color: #b9b9b9;
        font-size: 12px;
      }
    }
  }

  .experience-picker .vue-tags-input .ti-tag,
  .experience-picker .vue-tags-input .ti-selected-item,
  .picker-control li.selected {
    background-color: var(--primary-color);
    border-color: var(--primary-color);
  }

  .title-table {
    color: var(--primary-color);
  }
  .title-table2 {
    color: #666;
    cursor: pointer;
  }

  .bg-success {
    background-color: var(--primary-color) !important;
  }
}
</style>
